(ns builder.pages)

(defonce pages (atom {}))

(defn reg-page
  "register page under keyword for routing"
  ;;[key f & [layout-key]]
  [key page]
  (swap! pages assoc key page))
